var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"boutique",style:({backgroundImage:("url(" + (require('@/assets/img/boutique.png')) + ")")})}),_c('div',{staticClass:"presentation"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }